var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "clock-time-picker" },
    [
      _c(
        "v-text-field",
        _vm._b(
          {
            ref: "timeInput",
            staticClass: "align-icon-search",
            attrs: {
              value: _vm.displayValue,
              label: _vm.label,
              disabled: _vm.disabled,
              rules: _vm.rules
            },
            on: {
              focus: _vm.handleFieldFocus,
              click: function($event) {
                $event.stopPropagation()
                return _vm.handleFieldClick($event)
              },
              keydown: _vm.handleKeyDown,
              input: _vm.handleManualInput
            },
            scopedSlots: _vm._u([
              {
                key: "prepend-inner",
                fn: function() {
                  return [
                    _c("icon-svg", {
                      attrs: { name: "clock", size: "18", color: "#8e8e8e" }
                    })
                  ]
                },
                proxy: true
              }
            ])
          },
          "v-text-field",
          _vm.$attrs,
          false
        )
      ),
      _c(
        "v-menu",
        {
          attrs: {
            "close-on-content-click": false,
            "position-x": _vm.menuX,
            "position-y": _vm.menuY,
            absolute: "",
            "offset-y": "",
            transition: "scroll-y-transition",
            "max-width": "260",
            "min-width": "260"
          },
          model: {
            value: _vm.menuOpen,
            callback: function($$v) {
              _vm.menuOpen = $$v
            },
            expression: "menuOpen"
          }
        },
        [
          _c("div", { staticClass: "clock-time-picker__dropdown" }, [
            _c(
              "div",
              {
                staticClass:
                  "clock-time-picker__header d-flex align-center justify-center"
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "clock-time-picker__header-segment",
                    class: {
                      "clock-time-picker__header-segment--active":
                        _vm.clockMode === "hours"
                    },
                    on: { click: _vm.setModeHours }
                  },
                  [_vm._v(" " + _vm._s(_vm.headerHours) + " ")]
                ),
                _c(
                  "span",
                  { staticClass: "clock-time-picker__header-separator" },
                  [_vm._v(":")]
                ),
                _c(
                  "div",
                  {
                    staticClass: "clock-time-picker__header-segment",
                    class: {
                      "clock-time-picker__header-segment--active":
                        _vm.clockMode === "minutes"
                    },
                    on: { click: _vm.setModeMinutes }
                  },
                  [_vm._v(" " + _vm._s(_vm.headerMinutes) + " ")]
                )
              ]
            ),
            _c(
              "div",
              { staticClass: "clock-time-picker__clock-container" },
              [
                _c("ClockFace", {
                  attrs: { mode: _vm.clockMode, value: _vm.clockValue },
                  on: {
                    input: _vm.selectClockValue,
                    "drag-end": _vm.handleDragEnd
                  }
                })
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }